import React, { useState } from "react";
import {
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Utils from "../../utils";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { deletePartCatalogCheckList } from "../../services/PartsInventory";
import { createVehicleCheckList } from "../../services/VehiclePartCheckServices";

const AddVehiclePartCheck = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [partCheckData, setPartCheckData] = useState({
    id: "",
    vehicle_check_list: [
      {
        name: "",
        description: "",
        is_default: 0,
      },
    ],
  });

  const [btnLoader, setBtnLoader] = useState(false);

  const [delCheckModal, setDelCheckModal] = useState(false);
  const [isDelCheckButtonLoad, setIsDelCheckButtonLoad] = useState(false);
  const [delCheckpart, setDelCheckPart] = useState("");

  const handleAddChecklistRow = () => {
    const incomplete = partCheckData.vehicle_check_list?.some(
      (item) => !item.name.trim()
    );

    if (incomplete) {
      toast.error(t("toast_name_required_checklist"));
      return;
    }

    setPartCheckData((prev) => ({
      ...prev,
      vehicle_check_list: [
        ...(Array.isArray(prev.vehicle_check_list)
          ? prev.vehicle_check_list
          : []),
        {
          name: "",
          description: "",
          is_default: 0,
        },
      ],
    }));
  };

  const handleChecklistChange = (index, field, value) => {
    const updatedList = [...partCheckData.vehicle_check_list];
    updatedList[index][field] = value;
    setPartCheckData((prev) => ({
      ...prev,
      vehicle_check_list: updatedList,
    }));
  };

  const handleChecklistCheckbox = (index) => {
    const updatedList = [...partCheckData.vehicle_check_list];
    updatedList[index].is_default = updatedList[index].is_default === 1 ? 0 : 1;
    setPartCheckData((prev) => ({
      ...prev,
      vehicle_check_list: updatedList,
    }));
  };

  const handleDeleteChecklistRow = (index, item) => {
    if (item.id) {
      setDelCheckPart(item);
      setDelCheckModal(true);
    } else {
      const updatedList = partCheckData.vehicle_check_list.filter(
        (_, i) => i !== index
      );
      setPartCheckData((prev) => ({
        ...prev,
        vehicle_check_list: updatedList,
      }));
    }
  };

  const onRemoveCheckListRow = (e) => {
    e.preventDefault();
    setIsDelCheckButtonLoad(true);
    let data = { checklist_id: delCheckpart.id };
    deletePartCatalogCheckList(data)
      .then((response) => {
        toast.success(response.data.message);
        setDelCheckPart("");
        setDelCheckModal(false);
        setIsDelCheckButtonLoad(false);
      })
      .catch((err) => {
        setIsDelCheckButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const onDeleteCheckModalClose = () => {
    setDelCheckModal(false);
  };

  const handlePartCatalogForm = (e) => {
    e.preventDefault();

    setBtnLoader(true);

    let error = false;

    Utils.focusError();
    const hasEmptyName = partCheckData?.vehicle_check_list.some(
      (item) => !item.name?.trim()
    );

    if (hasEmptyName) {
      setBtnLoader(false);
      toast.error(t("toast_name_required_checklist_items"));
      return;
    }
    if (error) return;

    const vehicle_check_list = partCheckData?.vehicle_check_list?.map(
      (item) => ({
        name: item?.name,
        description: item?.description,
        is_default: item?.is_default,
        id: item?.id ? item?.id : "",
      })
    );

    let data = {
      vehicle_check_list: vehicle_check_list,
    };

    createVehicleCheckList(data)
      .then((response) => {
        toast.success(response.data.message);
        navigate("/check-list-vehicles");
        setPartCheckData({
          id: "",

          vehicle_check_list: [],
        });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setBtnLoader(false);
      });
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2 px-2">
            <div className="col-sm-6">
              <h1>{t("add_vehicle_part_check")}</h1>
            </div>
            <div className="col-sm-6"></div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row justify-content-start">
            <div className="col-md-12">
              <div className="card card-primary">
                <Form method={`post`} onSubmit={handlePartCatalogForm}>
                  <div className="card-body">
                    <div className="row">
                      <div
                        className="col-md-12"
                        style={{
                          marginTop: "15px",
                          marginBottom: "15px",
                        }}
                      >
                        <button
                          className="btn btn-primary"
                          onClick={handleAddChecklistRow}
                          type="button"
                        >
                          + Add Vehicle Check
                        </button>
                      </div>
                    </div>

                    <div className="row justify-content-start">
                      {partCheckData?.vehicle_check_list?.map((item, index) => (
                        <div className="col-md-6" key={index}>
                          <div className="fileupload-content px-4">
                            <div className="row justify-content-start align-items-center mb-2">
                              <div className="col-md-8">
                                <FormGroup>
                                  <Label className="col-form-label">Name</Label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={item.name}
                                    onChange={(e) =>
                                      handleChecklistChange(
                                        index,
                                        "name",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Name"
                                  />
                                </FormGroup>
                              </div>

                              <div className="col-md-4 d-flex align-items-center">
                                <FormGroup check>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={item.is_default === 1}
                                    onChange={() =>
                                      handleChecklistCheckbox(index)
                                    }
                                  />
                                  <Label className="form-check-label pl-2">
                                    Is Default
                                  </Label>
                                </FormGroup>

                                <button
                                  className="btn btn-danger trash-btn-custom btn-sm"
                                  onClick={() =>
                                    handleDeleteChecklistRow(index, item)
                                  }
                                  type="button"
                                >
                                  <i className="bi bi-trash"></i>
                                </button>
                              </div>

                              <div className="col-md-12">
                                <FormGroup>
                                  <Label className="col-form-label">
                                    Description
                                  </Label>
                                  <textarea
                                    className="form-control"
                                    type="text"
                                    value={item.description}
                                    onChange={(e) =>
                                      handleChecklistChange(
                                        index,
                                        "description",
                                        e.target.value
                                      )
                                    }
                                    placeholder="Description"
                                  />
                                </FormGroup>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="row">
                      <div className="col ms-2">
                        <button
                          type="button"
                          className="back-btn"
                          onClick={() => navigate("/check-list-vehicles")}
                        >
                          <i className="bi bi-arrow-left"> </i> {t("back")}
                        </button>
                      </div>
                      <div className="col">
                        <div className="d-flex justify-content-end nxt-btn">
                          {btnLoader === true ? (
                            <button type="submit" className="btn btn-primary">
                              Loading...
                            </button>
                          ) : (
                            <button type="submit" className="btn btn-primary">
                              {t("submit")} <i className="bi bi-check2"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-footer"></div>
                </Form>
              </div>
            </div>
          </div>

          <Modal isOpen={delCheckModal}>
            <ModalHeader>{`Delete CheckList`}</ModalHeader>
            <ModalBody>
              <p
                className={`mb-0`}
              >{`Are you sure you want to delete this part checklist?`}</p>
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                className="btn btn-block btn-primary"
                disabled={isDelCheckButtonLoad}
                onClick={onDeleteCheckModalClose}
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("close")} <i className="bi bi-x-lg"></i>
              </button>

              {!isDelCheckButtonLoad && (
                <button
                  type="button"
                  className="btn btn-block bg-red"
                  style={{ width: "100px" }}
                  onClick={onRemoveCheckListRow}
                >
                  {t("delete")} <i className="bi bi-trash3"></i>
                </button>
              )}
              {isDelCheckButtonLoad && (
                <button
                  color="secondary"
                  type={`button`}
                  disabled={true}
                  className={`btn-square`}
                >
                  <i className="fa fa-circle-o-notch fa-spin"></i>{" "}
                  {`Loading...`}
                </button>
              )}
            </ModalFooter>
          </Modal>
        </div>
      </section>
    </div>
  );
};

export default AddVehiclePartCheck;
